import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Postgres `decimal` columns come back as strings like "21500.00", which look
 * broken inside number inputs. Strip the padding zeros while keeping any real
 * decimals ("21500.00" -> "21500", "21500.50" -> "21500.5").
 *
 * Returns "" for null/undefined/empty and leaves non-numeric input untouched.
 */
export function toNumericInputValue(
  value: string | number | null | undefined,
): string {
  if (value === null || value === undefined) return "";

  const raw = String(value).trim();
  if (raw === "") return "";

  const num = Number(raw);
  if (Number.isNaN(num)) return raw;

  // Avoid exponential notation for very small/large values.
  return String(parseFloat(num.toFixed(10)));
}
